import * as React from "react";
import PropTypes from "../../../../../../prop-types/index.es.js";
import { useGridApiContext } from "../../../../hooks/utils/useGridApiContext.es.js";
import { useGridRootProps } from "../../../../hooks/utils/useGridRootProps.es.js";
import { j as jsxRuntimeExports } from "../../../../../../react/jsx-runtime.es.js";
import { gridVisibleColumnDefinitionsSelector } from "../../../../hooks/features/columns/gridColumnsSelector.es.js";
import MUIMenuItem from "../../../../../material/MenuItem/MenuItem.es.js";
import ListItemIcon from "../../../../../material/ListItemIcon/ListItemIcon.es.js";
import ListItemText from "../../../../../material/ListItemText/ListItemText.es.js";
function GridColumnMenuHideItem(props) {
  const {
    colDef,
    onClick
  } = props;
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const visibleColumns = gridVisibleColumnDefinitionsSelector(apiRef);
  const columnsWithMenu = visibleColumns.filter((col) => col.disableColumnMenu !== true);
  const disabled = columnsWithMenu.length === 1;
  const toggleColumn = React.useCallback((event) => {
    if (disabled) {
      return;
    }
    apiRef.current.setColumnVisibility(colDef.field, false);
    onClick(event);
  }, [apiRef, colDef.field, onClick, disabled]);
  if (rootProps.disableColumnSelector) {
    return null;
  }
  if (colDef.hideable === false) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(MUIMenuItem, {
    onClick: toggleColumn,
    disabled,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ListItemIcon, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(rootProps.slots.columnMenuHideIcon, {
        fontSize: "small"
      })
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemText, {
      children: apiRef.current.getLocaleText("columnMenuHideColumn")
    })]
  });
}
process.env.NODE_ENV !== "production" ? GridColumnMenuHideItem.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  colDef: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
} : void 0;
export {
  GridColumnMenuHideItem
};
//# sourceMappingURL=GridColumnMenuHideItem.es.js.map
